.outer-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-grow: 1;
}

.left-container {
    width: 70%;
    display: flex;
    justify-content: center;
    overflow: auto;
}

.right-container {
    width: 30%;
    display: flex;
    flex-direction: column;
    gap: 16px;
    overflow: auto;
    flex-shrink: 0;
    padding: 16px;
}

.right-container > div {
    height: auto;
    flex-shrink: 0;
}

.right-container > div:not(:first-child) {
    margin-top: 0;
}
